"use client";

import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "@/lib/api-client";
import type { Aviso } from "@/types/avisos";

export function useAvisos() {
  const [avisos, setAvisos] = useState<Aviso[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchAvisos = useCallback(async () => {
    try {
      const res = await apiFetch("/api/v1/avisos");
      if (res.ok) {
        const data = await res.json();
        setAvisos(data.data ?? []);
      }
    } catch {
      // silently ignore — network errors don't break the page
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAvisos();
  }, [fetchAvisos]);

  const arquivarAviso = useCallback(async (id: number) => {
    const res = await apiFetch(`/api/v1/avisos/${id}`, { method: "DELETE" });
    if (res.ok) {
      setAvisos((prev) => prev.filter((a) => a.id !== id));
    }
    return res.ok;
  }, []);

  return { avisos, loading, refresh: fetchAvisos, arquivarAviso };
}
